import React from "react";
import "react-popupbox/dist/react-popupbox.css";
import hotels from '../asset/img/hotels.PNG'
import inventory from '../asset/img/inventory.PNG'
import tatoos from '../asset/img/tatoos.PNG'
import native from '../asset/img/native.png'
import give4 from '../asset/img/give4.PNG'
import ecommercePNG from '../asset/img/ecommerce.PNG'
import portafolio from '../asset/img/portafolio.PNG'
import { PopupboxManager, PopupboxContainer } from "react-popupbox";

const Portafolio = () => {

  const showHotels = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={hotels} alt="Campamento" />
        <div className="mt-2">
        <p className="portafolio-p mt-2">Proyecto de reserva de hoteles</p>
        <b>Demo:</b> <a className="hyper-link" onClick={() => window.open("https://rafa-hotels.netlify.app", "_blank")}>https://rafa-hotels.netlify.app</a>
        <br />
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'React Redux'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showPortafolio = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={portafolio} alt="Campamento" />
        <div className="mt-2">
        <p className="portafolio-p mt-2">Página profesional de presentación </p>
        <br />
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Portafolio'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showInventory = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={inventory} alt="Integral" />
        <div className="mt-2">
        <p className="portafolio-p mt-2">Proyecto de sistema de inventario</p>
        <b>Demo:</b> <a className="hyper-link" onClick={() => window.open("https://system-inventory.netlify.app", "_blank")}>https://system-inventory.netlify.app</a>
        <br />
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'React JS'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showTattoos = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={tatoos} alt="Proyecto de tatuajes " />
        <div className="mt-2">
        <p className="portafolio-p mt-2">Proyecto de inscripción a promociones mensuales</p>
        <p className="portafolio-p mt-2">User: usertest@yopmail.com </p>
        <p className="portafolio-p mt-2">Password: 123456789 </p>
        <b>Demo:</b> <a className="hyper-link" onClick={() => window.open("https://brown-pride-tattoo-shop.web.app", "_blank")}>https://brown-pride-tattoo-shop.web.app</a>
        <br />
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'React TypeScript'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showNative = () => {
    const content = (
      <>
        <img className="portafolio-image-oratoria" src={native} alt="Native" />
        <div className="mt-2">
        <p className="portafolio-p mt-2">Proyecto de administración de alcaldías</p>
        <b>Demo:</b> <a className="hyper-link" onClick={() => window.open("https://mega.nz/file/bAdkwZpQ#__7A4YTLDVYdOo3EJzxxIHd44039j0lxNWtsH9RMfg4", "_blank")}>https://mega.nz/file/bAdkwZpQ#__7A4YTLDVYdOo3EJzxxIHd44039j0lxNWtsH9RMfg4</a>
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'React Native'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showGive4 = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={give4} alt="1° lugar" />
        <div className="mt-2">
        <p className="portafolio-p mt-2">Colaborador de proyecto de donaciones</p>
        <b>Demo:</b> <a className="hyper-link" onClick={() => window.open("https://give4love-a9d91.web.app/#/login", "_blank")}>https://give4love-a9d91.web.app/#/login</a>
        <br />
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Angular JS'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }
  const showEcommer = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={ecommercePNG} alt="1° lugar" />
        <div className="mt-2">
        <p className="portafolio-p mt-2">Proyecto de ecommerce con integracion de pasarela de pago wompi</p>
        {/* <b>Demo:</b> <a className="hyper-link" onClick={() => window.open("https://rafa-shop-online.web.app/signin", "_blank")}>https://rafa-shop-online.web.app/signin</a> */}
        <br />
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'React, Redux, MongoDB, Wompi, Node , Express'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  

  return (
    <section className="ftco-section2 ftco-project" id="portafolio">
      <div className="container-fluid px-md-0">
        <div className="row no-gutters justify-content-center pb-5">
          <div className="col-md-12 heading-section text-center ftco-animate">
          <h1 className="big big-2">Projects</h1>
          <h2 className="mb-4 text-uppercase colorTexto">Portafolio</h2>
          <p>Proyectos que he desarrollo como práctica y en el mundo laboral</p>
          </div>
        </div>
        <div className="row no-gutters">

          <div className="col-md-4">
            <div onClick={showTattoos} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${tatoos})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
              <h3><a>Proyecto de inscripción y notificación mensual de promociones</a></h3>
              <span>React TypeScript</span>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showGive4} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${give4})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
              <h3><a>Colaborador de proyecto donaciones</a></h3>
              <span>Angular JS</span>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showInventory} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${inventory})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
              <h3><a>Proyecto de inventario</a></h3>
              <span>React JS</span>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showNative} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${native})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
              <h3><a>Proyecto de administración de alcaldías</a></h3>
              <span>React Native JS</span>
              </div>
            </div>
          </div>

          <div className="col-md-4 " >
            <div onClick={showHotels} className="project img ftco-animate d-flex justify-content-center align-items-center portfolio-image-box" style={{ backgroundImage: `url(${hotels})` }} >            <div className="overlay"></div>
              <div className="text text-center p-4">
              <h3><a>Proyecto de reserva de hoteles</a></h3>
              <span>React, Redux JS</span>
              </div>
            </div>
          </div>

          <div className="col-md-4 " >
            <div onClick={showEcommer} className="project img ftco-animate d-flex justify-content-center align-items-center portfolio-image-box" style={{ backgroundImage: `url(${ecommercePNG})` }} >            <div className="overlay"></div>
              <div className="text text-center p-4">
              <h3><a>Proyecto ecommerce </a></h3>
              <span>React, Redux, MongoDB, Wompi, Node, Express</span>
              </div>
            </div>
          </div>
          <div className="col-md-4 " >
            <div onClick={showPortafolio} className="project img ftco-animate d-flex justify-content-center align-items-center portfolio-image-box" style={{ backgroundImage: `url(${portafolio})` }} >            <div className="overlay"></div>
              <div className="text text-center p-4">
              <h3><a>Proyecto de presentación personal</a></h3>
              <span>React JS</span>
              </div>
            </div>
          </div>
          
          <PopupboxContainer />
        </div>
      </div>
    </section>
  );
};

export default Portafolio;
